/* Copyright 2025 Supovia LLC */
import failure from './failure.js'

export default function httpWithoutHeaders(url, customFailure) {
  return fetch(url)
    .then(response => {
      if (!response.ok) {
        return response.json().then(error => {
          throw error
        })
      }
      return response.json()
    })
    .catch(customFailure || failure)
}
